import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './components/loader/loader.component';
import { filter, map, mergeMap } from 'rxjs';
import { TitleService } from './utils/TitleService';
import { RouteTitle } from './utils/symbol.util';
import { IdleTimeoutService } from './auth/timeout/idle-timeout.service';
import { ClickjackingPreventionService } from './auth/interceptors/clickjacking-prevention.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    LoaderComponent,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  title = 'mesfs-ui-app';
  private clickjackingPreventionService = inject(ClickjackingPreventionService);

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService,
    private idleTimeoutService: IdleTimeoutService,
    private _elementRef: ElementRef
  ) {
    this.clickjackingPreventionService.preventClickjacking();
    this.listenRouteEvents();
    // Start tracking user activity
    this.idleTimeoutService.trackUserActivity();
  }

  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute("ng-version");
    this.verifyLogin();
  }

  verifyLogin() {
    const userLoggedIn: Boolean = Boolean(localStorage.getItem('userLoggedIn'));

    if (userLoggedIn) {
      this.router.navigate(['/app/home'], { replaceUrl: true });
    } else {
      this.router.navigate(['/app/login']);
    }
  }

  private listenRouteEvents(): void {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }))
      .pipe(filter((d) => d.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      .subscribe(event => {
        console.log(event);
        this.titleService.setTitle(event[RouteTitle]);
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        console.log(event.url);
        // switch (event.url) {
        //   case '/app':
        //   case '/app/dashboard':
        //     event.url = '/app/appointment/newAppointment';
        //     this.pageContextService.setPageContext(event as PageContext);
        //     break;
        //   default:
        //     if (event.url !== '/app/search') {
        //       this.pageContextService.setPageContext(event as PageContext);
        //       console.log(event.url);
        //     }
        //     break;
        // }
      }
    });
  }
}
